<template>
	<!-- 达人联系人 -->
	<div class="drContactsCell">
		<el-select
			class="dr-select"
			style="width: 100%;"
			ref="template"
			v-model="nickName"
			:loading-text="loading_cont"
			:popper-append-to-body="false"
			clearable
			filterable
			:loading="loadingContact_cont"
			remote
			@change="selectChange"
			:remote-method="remoteContactMethod_cont"
			@visible-change="v => visibleChange(v, 'template')"
			@focus="focusContactFun_cont"
			placeholder="请选择 / 搜索"
		>
			<el-option v-for="(item, index) in contactOptions" :key="index" :value="item.nick_name" :label="item.nick_name">
				<div class="flex flex-align-center dr-list">
					<div class="dr-list-li">
						<span class="contact-name">{{ item.nick_name }}</span>
						<span v-if="item.mobile">/</span>
						<span>{{ item.mobile }}</span>
					</div>
				</div>
			</el-option>
		</el-select>
		<linkman-dialog ref="linkmanDialog" @onInject="getContact" />
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import linkmanDialog from '@/views/talentCRM/components/linkmanDialog';
import { contactList } from '@/api/extenTecord';
export default {
	name: 'drContactsCell',
	mixins: [mixin],
	props: {},
	mounted() {
		this.$Bus.$on('sendContactOptions', val => {
			this.parentList = val;
		});
	},
	beforeDestroy() {
		this.$Bus.$off('sendContactOptions');
	},
	watch: {
		nickName(val) {
			this.row.isGetAddress = true;
			const anchorContactId = val ? this.anchorContactId || this.contactOptions?.find(v => v.nick_name === val)?.id : '';
			const nickName = val;
			this.anchorContactId = '';
			this.row.isChecked = true;
			this.$Bus.$emit('drSelectChange', anchorContactId, this.rowId, nickName);
			//推出去将数据将对应的达人联系人id绑定了
		},
		rowId(newval, oldval) {
			this.anchorContactId = this.parentList?.find(v => v.id == this.rowId)?.team_institution_id;
			this.nickName = this.parentList?.find(v => v.id == this.rowId)?.nickName;
			this.$Bus.$emit('resetTzId', oldval);
		},
	},
	computed: {
		rowId() {
			return this.row.id;
		},
	},
	data() {
		return {
			nickName: '',
			loading_cont: '加载中',
			loadingContact_cont: false,
			contactOptions: [], //存储了列表中的id和contact_name
			isShowRadio: false,
			parentList: [],
			selectDaren: '',
			dataMap: {},
			isShow: true,
			anchorContactId: '',
		};
	},
	components: {
		linkmanDialog
	},
	methods: {
		visibleChange(visible, refName) {
			if (visible) {
				const ref = this.$refs[refName];
				let popper = ref.$refs.popper;
				if (popper.$el) popper = popper.$el;
				// todo wzj !Array.from(popper.children).some(v => v.className === 'el-template-menu__list') && this.$auth.hasPermi('team-sea:sea-claim')
				if (!Array.from(popper.children).some(v => v.className === 'el-template-menu__list')) {
					const el = document.createElement('ul');
					el.className = 'el-template-menu__list';
					el.style = 'padding:0; color:rgb(64 158 255);font-size: 13px';
					el.innerHTML = `<li class="el-cascader-node text-center" style="height:37px;line-height: 50px">
                        <span class="yx-color-primary"><i class="font-blue el-icon-plus mr-4"></i>新增联系人</span>
                        </li>`;
					popper.appendChild(el);
					el.onclick = () => {
						this.addContacts();
					};
				}
			}
		},
		selectChange(e) {},
		//联系人远程搜索
		async remoteContactMethod_cont(e) {
			this.loadingContact_cont = true;
			this.loading_cont = '加载中';
			const { code, data } = await contactList({ anchor_id: this.row.id, nick_name: e, unbind_wechat: this.isShowRadio ? '1' : '' });
			this.loadingContact_cont = false;
			if (code == 0) {
				this.contactOptions = data.list;
			}
		},
		async focusContactFun_cont(e) {
			this.loadingContact_cont = true;
			this.loading_cont = '加载中';
			const { code, data } = await contactList({
				anchor_id: this.row.id,
				nick_name: '',
				unbind_wechat: this.isShowRadio ? '1' : '',
			});
			if (code == 0) {
				this.contactOptions = data.list;
				data.list.length ? (this.loadingContact_cont = false) : (this.loading_cont = '无数据');
			}
		},
		//添加联系人
		addContacts() {
			const { anchor_name, anchor_account, head, platform_id, id: anchor_id } = this.row;
			const anchor_info = {
				anchor_name,
				anchor_account,
				head,
				platform_id,
			};
			// 需要传3个参数，第一个为建联需要的表单，第二个为当前对象，第三个为新建还是关联联系人1或0
			this.$refs.linkmanDialog.show(
				{
					anchor_id,
					operate_time: Date.now(),
					is_pass: 1,
					contact_type: 1,
				},
				anchor_info,
				1,
			);
		},
		//新增联系人之后
		getContact(params) {
			this.nickName = params?.contact_name;
			this.anchorContactId = params?.id;
		},
	},
};
</script>
<style lang="less" scoped>
.contact-name {
	float: left;
	color: #1d2129;
	margin-left: 10px;
}
/deep/ .el-input__inner {
	font-size: 12px !important;
}
.dr-select {
	/deep/ .el-select-dropdown__item {
		padding: 0px !important;
		height: 100% !important;
		line-height: 19px !important;
	}
	/deep/ .el-scrollbar__wrap{
		max-height: 306px;
	}
	/deep/ .el-select-dropdown{
		border-color: @color-gy3;
	}
}
.dr-list {
	border-bottom: 1px solid @color-gy3;
	.dr-list-li{
		padding: 8px 12px 8px 12px;
	}
}
/deep/ .el-select {
  .el-select__caret:first-child::before {
    content: "\e6e1";
  }
  .is-focus {
    .el-select__caret:first-child {
      transform: rotateZ(0deg);
    }
  }
}
</style>
